<router-outlet />
@defer (when showDevelopmentModePanel) {
  <app-state-monitor />
}
